import { Box, Typography, styled } from "@mui/material";
import { CustomDisplayItem } from "@/components/custom/custom-display-item";
import { formatUnderscoreLabel } from "@/utils/format-underscore-label";

const Row = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(3),
  [theme.breakpoints.up("lg")]: { flexDirection: "row" },
}));

const Grid = styled(Box)(({ theme }) => ({
  flex: 1,
  display: "grid",
  gridTemplateColumns: "1fr",
  gap: theme.spacing(2),
  [theme.breakpoints.up("md")]: { gridTemplateColumns: "1fr 1fr" },
}));

const Side = styled(Box)(({ theme }) => ({
  flexShrink: 0,
  [theme.breakpoints.up("lg")]: { width: 256 },
}));

const SectionTitle = ({ title, description }) => (
  <Side>
    <Typography fontWeight={500} fontSize={18}>
      {title}
    </Typography>
    {description && (
      <Typography variant="body2" color="text.secondary">
        {description}
      </Typography>
    )}
  </Side>
);

const KycBusinessInfo = ({ d }) => {
  return (
    <Row>
      <SectionTitle
        title="Business Information"
        description="Core details about the registered business."
      />
      <Grid>
        <Box sx={{ backgroundColor: "background.paper" }}>
          <CustomDisplayItem label="Business Name" value={d?.businessName} />
        </Box>
        <Box sx={{ backgroundColor: "background.paper" }}>
          <CustomDisplayItem
            label="Business Description"
            value={d?.businessDescription}
          />
        </Box>
        <Box sx={{ backgroundColor: "background.paper" }}>
          <CustomDisplayItem
            label="Business Type"
            value={formatUnderscoreLabel(d?.businessType)}
          />
        </Box>
        <Box sx={{ backgroundColor: "background.paper" }}>
          <CustomDisplayItem
            label="Registration Type"
            value={formatUnderscoreLabel(d?.businessRegistrationType)}
          />
        </Box>
        <Box sx={{ backgroundColor: "background.paper" }}>
          <CustomDisplayItem
            label="Registration Number"
            value={d?.businessRegistrationNumber}
          />
        </Box>
        <Box sx={{ backgroundColor: "background.paper" }}>
          <CustomDisplayItem
            label="Industry"
            value={d?.businessIndustry?.name}
          />
        </Box>
        <Box sx={{ backgroundColor: "background.paper" }}>
          <CustomDisplayItem
            label="Nationality"
            value={d?.businessNationality || "-"}
          />
        </Box>
        <Box sx={{ backgroundColor: "background.paper" }}>
          <CustomDisplayItem label="TIN" value={d?.tin || "-"} />
        </Box>
        <Box sx={{ backgroundColor: "background.paper" }}>
          <CustomDisplayItem
            label="Approval Status"
            value={formatUnderscoreLabel(d?.approvalStatus)}
          />
        </Box>
      </Grid>
    </Row>
  );
};

export default KycBusinessInfo;
